import { createSlice } from '@reduxjs/toolkit';
import { initialState } from '../../../data/entitlement/customers/initialState.customersSearch.data';
import { CHECK_BOX_VALUE } from '../../../constants';
import {
  fetchAccountingGroupsData as fetchAccountingGroupsAPI,
  byGlobalCustomersNo as byGlobalCustomersNoAPI,
  byMultipleInputs as byMultipleInputsAPI,
  getDetailsByCostomerId as getDetailsByCostomerIdAPI,
  getAddressDetailsByCostomerId as getAddressDetailsByCostomerIdAPI,
  getCustomerHistory as getCustomerHistoryAPI,
  getCustomerChildren as getCustomerChildrenAPI,
  getCustomerNotes as getCustomerNotesAPI,
  addCustomerNotes as addCustomerNotesAPI,
  deleteCustomerNotes as deleteCustomerNotesAPI,
  orderNumberSmartSearch as orderNumberSmartSearchAPI,
  siteIDSmartSearch as siteIDSmartSearchAPI,
  getCustomersBy_OrderNumber_SiteID as getCustomersBy_OrderNumber_SiteIDAPI,
  bySearchEntitlementSummary as bySearchEntitlementSummaryAPI,
  bySearchCustomerSite as bySearchCustomerSiteAPI,
  fetchCustomerBillNotes as fetchCustomerBillNotesAPI,
  fetchCustomerBillingBills as fetchCustomerBillingBillsAPI,
  updateCustomersInfo as updateCustomersInfoAPI,
  getViewBillData as getViewBillDataAPI,
  sendEntitlementSummaryEmail as sendEntitlementSummaryEmailAPI,
} from '../../../apis/customersSearchAPI';
import { ACTIONS_CUSTOMERS } from '../../../constants/actionCreator';
import { createAsyncThunkWrapper } from '../../../services/common/asyncThunkWrapper';
import { globalDateFormat } from '../../../utils/common';

export const customerNameSmartSearchData = createAsyncThunkWrapper(
  ACTIONS_CUSTOMERS.SEARCH_PRODUCT_NAME_CONTAINS,
  byMultipleInputsAPI
);

export const fetchAccountingGroups = createAsyncThunkWrapper(
  ACTIONS_CUSTOMERS.FETCH_ACCOUNTING_GROUPS,
  fetchAccountingGroupsAPI
);

export const getSearchByCostomerId = createAsyncThunkWrapper(
  ACTIONS_CUSTOMERS.SEARCH_BY_GLOBAL_CUSTOMER_NO,
  byGlobalCustomersNoAPI
);

export const getSearchByMultipleInputs = createAsyncThunkWrapper(
  ACTIONS_CUSTOMERS.SEARCH_ALL_CUSTOMERS_BY_MULTIPLE_INPUTS,
  byMultipleInputsAPI
);

export const getDetailsByCostomerId = createAsyncThunkWrapper(
  ACTIONS_CUSTOMERS.GET_DETAILS_BY_CUSTOMER_ID,
  getDetailsByCostomerIdAPI
);

export const getAddressDetailsByCostomerId = createAsyncThunkWrapper(
  ACTIONS_CUSTOMERS.GET_ADDRESS_DETAILS_BY_CUSTOMER_ID,
  getAddressDetailsByCostomerIdAPI
);

export const getSearchByMultipleInputsParentGlobalModal =
  createAsyncThunkWrapper(
    ACTIONS_CUSTOMERS.SEARCH_ALL_CUSTOMERS_FOR_PARENT_GLOBAL_MODAL,
    byMultipleInputsAPI
  );

export const getCustomerHistory = createAsyncThunkWrapper(
  ACTIONS_CUSTOMERS.GET_CUSTOMER_HISTORY,
  getCustomerHistoryAPI
);

export const getCustomerChildren = createAsyncThunkWrapper(
  ACTIONS_CUSTOMERS.GET_CUSTOMER_CHILDREN,
  getCustomerChildrenAPI
);

export const getCustomerNotes = createAsyncThunkWrapper(
  ACTIONS_CUSTOMERS.GET_CUSTOMER_NOTES,
  getCustomerNotesAPI
);

export const addCustomerNotes = createAsyncThunkWrapper(
  ACTIONS_CUSTOMERS.ADD_CUSTOMER_NOTES,
  addCustomerNotesAPI
);

export const deleteCustomerNotes = createAsyncThunkWrapper(
  ACTIONS_CUSTOMERS.DELETE_CUSTOMER_NOTES,
  deleteCustomerNotesAPI
);

export const bySearchEntitlementSummary = createAsyncThunkWrapper(
  ACTIONS_CUSTOMERS.SEARCH_CUSTOMER_ENTITLEMENT_SUMMARY,
  bySearchEntitlementSummaryAPI
);

export const orderNumberSmartSearchData = createAsyncThunkWrapper(
  ACTIONS_CUSTOMERS.ORDER_NUMBER_SMART_SEARCH,
  orderNumberSmartSearchAPI
);

export const siteIDSmartSearchData = createAsyncThunkWrapper(
  ACTIONS_CUSTOMERS.SITE_ID_SMART_SEARCH,
  siteIDSmartSearchAPI
);

export const getCustomersBy_OrderNumber_SiteID = createAsyncThunkWrapper(
  ACTIONS_CUSTOMERS.SALES_ORDER_CUSTOMER_SEARCH,
  getCustomersBy_OrderNumber_SiteIDAPI
);

export const bySearchCustomerSite = createAsyncThunkWrapper(
  ACTIONS_CUSTOMERS.SEARCH_CUSTOMER_SITE,
  bySearchCustomerSiteAPI
);

export const fetchCustomerBillNotesData = createAsyncThunkWrapper(
  ACTIONS_CUSTOMERS.FETCH_CUSTOMER_BILL_NOTES,
  fetchCustomerBillNotesAPI
);

export const fetchCustomerBillingBills = createAsyncThunkWrapper(
  ACTIONS_CUSTOMERS.FETCH_CUSTOMER_BILLS_BILL,
  fetchCustomerBillingBillsAPI
);

export const updateCustomersInfo = createAsyncThunkWrapper(
  ACTIONS_CUSTOMERS.UPDATE_CUSTOMERS_INFO,
  updateCustomersInfoAPI
);

export const viewBillingData = createAsyncThunkWrapper(
  ACTIONS_CUSTOMERS.VIEW_BILLING,
  getViewBillDataAPI
);

export const entitlementSummaryEmail = createAsyncThunkWrapper(
  ACTIONS_CUSTOMERS.SEND_ENTITLEMENT_SUMMARY_EMAIL,
  sendEntitlementSummaryEmailAPI
);

const CustomersSearchSlice = createSlice({
  name: 'customers',
  initialState,
  reducers: {
    resetValues: () => initialState,

    customerDetailResetValues: (state) => {
      state.customerHistory = initialState.customerHistory;
      state.selectedRowData = initialState.selectedRowData;
      state.customerDetails = initialState.customerDetails;
      state.addressDetails = initialState.addressDetails;
      state.customerHistoryDataFound = initialState.customerHistoryDataFound;
      state.customerChildrenDataFound = initialState.customerChildrenDataFound;
      state.customerChildren = initialState.customerChildren;
      state.customerNotesDataFound = initialState.customerNotesDataFound;
      state.customerNotes = initialState.customerNotes;
      state.selectedTabValue = initialState.selectedTabValue;
      state.customerBackToPrevious = initialState.customerBackToPrevious;
      state.salesOrdersCustomers = initialState.salesOrdersCustomers;
      state.salesOrdersTotalCount = initialState.salesOrdersTotalCount;
      state.isSalesOrderDataFound = initialState.isSalesOrderDataFound;
      state.customerEntitlementSummary =
        initialState.customerEntitlementSummary;
      state.customerEntitlementSummaryDataFound =
        initialState.customerEntitlementSummaryDataFound;
      state.customerInfoUpdated = initialState.customerInfoUpdated;
    },

    setSelectedComponent: (state, action) => {
      state.selectedComponent = action?.payload;
      state.globalCustomerNo = initialState.globalCustomerNo;
      state.multipleInputsSelectedValues =
        initialState.multipleInputsSelectedValues;
      state.dropDownValues = initialState.dropDownValues;
      state.name = initialState.name;
    },
    setSelectedRowData: (state, action) => {
      state.selectedRowData = action?.payload;
    },

    setSelectedValue: (state, action) => {
      if (state.parentGlobalModal.openParentGlobalCustomerNoModal) {
        state.parentGlobalModal.parentGlobalModalMultipleInputs[
          action.payload.name
        ] = action?.payload?.value;
      } else {
        state.multipleInputsSelectedValues[action.payload.name] =
          action.payload.value;
      }
    },
    setCustomerNameInputValue: (state, action) => {
      if (state.parentGlobalModal.openParentGlobalCustomerNoModal) {
        state.parentGlobalModal.parentGlobalModalMultipleInputs[
          action.payload.name
        ] = action?.payload?.value;
      } else {
        state.selectedCustomerNameInputValue[action.payload.name] =
          action.payload.value;
      }
    },
    setDropDownValue: (state, action) => {
      if (state.parentGlobalModal.openParentGlobalCustomerNoModal) {
        state.parentGlobalModal.parentGlobalModalDropDownValues[
          action.payload.name
        ] = action?.payload?.value;
      } else {
        state.dropDownValues[action.payload.name] = action?.payload?.value;
      }
    },

    setSelectedAccountGridRowsData: (state, action) => {
      state.accountingGroupModal.gridAccountingRowSelectedData =
        action?.payload;
      state.accountingGroupModal.gridAccountingRowSelectedCount =
        action.payload?.length;
      if (state.parentGlobalModal.openParentGlobalCustomerNoModal) {
        state.parentGlobalModal.parentGlobalModalMultipleInputs.accountingGroup =
          action.payload[0]?.accountingGroupCode
            ? action.payload[0].accountingGroupCode?.trim()
            : '';
      } else {
        state.multipleInputsSelectedValues.accountingGroup = action?.payload[0]
          ?.accountingGroupCode
          ? action.payload[0].accountingGroupCode?.trim()
          : '';
      }
    },
    setSelectedParentGlobalGridRowsData: (state, action) => {
      state.parentGlobalModal.gridParentGlobalCustomerNoRowSelectedData =
        action.payload;
      state.parentGlobalModal.gridParentGlobalGridRowSelectedCount =
        action.payload?.length;
      state.multipleInputsSelectedValues.parentPsCustomerCode =
        action.payload[0]?.psCustomerCode;
    },
    setCustomerNumber: (state, action) => {
      state.multipleInputsSelectedValues.parentPsCustomerCode = action?.payload;
    },
    setAccountingGroupModalOpen: (state) => {
      state.accountingGroupModal.openAccountingGroupModal = true;
      state.accountingGroupModal.accountingGroupSearchForm =
        initialState.accountingGroupModal.accountingGroupSearchForm;
      state.accountingGroupModal.accountingGroupSearchData = [];
    },
    setAccountingGroupModalClose: (state) => {
      state.accountingGroupModal.openAccountingGroupModal = false;
      state.accountingGroupModal.accountingGroupSearchForm =
        initialState.accountingGroupModal.accountingGroupSearchForm;
    },
    setParentGlobalCustomerNoModalOpen: (state) => {
      state.parentGlobalModal.openParentGlobalCustomerNoModal = true;
    },
    setParentGlobalCustomerNoModalClose: (state) => {
      state.parentGlobalModal.openParentGlobalCustomerNoModal = false;
      state.parentGlobalModal = initialState.parentGlobalModal;
    },
    setAccouningGroupFormFeilds: (state, action) => {
      state.accountingGroupModal.accountingGroupSearchForm[
        action.payload.name
      ] = action?.payload?.value;
    },

    setDisplayButtonValue: (state, action) => {
      state.displayButtonValue = action?.payload;
      if (!action.payload) {
        state.customerDetails = initialState.customerDetails;
        state.addressDetails = initialState.addressDetails;
      }
    },

    setSelectedTabValue: (state, action) => {
      state.selectedTabValue = action?.payload;
    },
    setIsExpandedValue: (state, action) => {
      state.isExpanded = action?.payload;
    },
    setGlobalCustomerNo: (state, action) => {
      state.globalCustomerNo = action?.payload;
    },
    setBillToCustomerChange: (state, action) => {
      const { name, checked } = action?.payload || {};
      state.billToCustomerCheckbox[name] = checked
        ? CHECK_BOX_VALUE.yes
        : CHECK_BOX_VALUE.no;
    },

    setCustomerNameSearchTerm: (state, action) => {
      if (state.parentGlobalModal.openParentGlobalCustomerNoModal) {
        state.parentGlobalModal.customerNameSearchTerm = action?.payload;
      } else {
        state.customerNameSearchTerm = action?.payload || '';
      }
    },

    setShowCustomernameSelectedValue: (state, action) => {
      if (state.parentGlobalModal.openParentGlobalCustomerNoModal) {
        state.parentGlobalModal.showCustomernameSelectedValue = action?.payload;
      } else {
        state.showCustomernameSelectedValue = action?.payload;
      }
    },

    setCustomersGridPageSize: (state, action) => {
      if (state.parentGlobalModal.openParentGlobalCustomerNoModal) {
        state.parentGlobalModal.parentGlobalModalMultipleInputs.recordCount =
          action.payload;
      } else {
        state.multipleInputsSelectedValues.recordCount = action?.payload;
      }
    },

    setCloseAlertDialog: (state) => {
      state.errorModal = null;
    },

    displayEnterValue: (state) => {
      state.errorModal = 'enterValue';
      state.selectedRowData = [];
      state.displayButtonValue = false;
    },

    setBackToPreviousPage: (state, action) => {
      if (action?.payload?.name === 'add') {
        state.customerBackToPrevious.push(action.payload.id);
      }
      if (action?.payload?.name === 'remove') {
        state.customerBackToPrevious = state.customerBackToPrevious?.filter(
          (item) => item !== action?.payload?.id
        );
      }
      if (action?.payload?.name === 'clear') {
        state.customerBackToPrevious = [];
      }
    },

    setCustomerNotesOpenCloseModal: (state, action) => {
      state.isCustomerNotesModalOpen = !action.payload;
    },

    customerAddNotesState: (state, action) => {
      if (action.payload.name) {
        state.addCustomerNotes[action.payload.name] = action?.payload?.value;
      } else {
        state.addCustomerNotes = action?.payload;
      }
    },

    setDisplayDeleteAlert: (state, action) => {
      state.displayDeleteAlert = action?.payload;
    },

    setEditNoteData: (state, action) => {
      state.editNoteData = action?.payload;
    },

    setHandelReset: (state) => {
      state.salesOrdersCustomers = initialState.salesOrdersCustomers;
      state.salesOrdersTotalCount = initialState.salesOrdersTotalCount;
      state.isSalesOrderDataFound = initialState.isSalesOrderDataFound;
      state.orderNumber = initialState.orderNumber;
      state.siteID = initialState.siteID;
    },

    setEffectiveDate: (state, action) => {
      state.customerEntitlementSummaryEffectiveDate = action?.payload;
    },

    setStatus: (state, action) => {
      state.customerEntitlementSummaryStatus = action?.payload;
    },

    setSearch: (state, action) => {
      state.isReset = action?.payload;
    },

    setSiteNameContaines: (state, action) => {
      state.customerSitesNameContains = action?.payload;
    },

    setSiteNcrIdContaines: (state, action) => {
      state.customerNcrSitesIdContains = action?.payload;
    },

    setSiteActive: (state, action) => {
      state.customerSitesActive = action?.payload;
    },

    setNavigateToSite: (state, action) => {
      state.isNavigateToSiteModule = action?.payload;
    },

    setAGOnChange: (state, action) => {
      if (state.parentGlobalModal.openParentGlobalCustomerNoModal) {
        state.parentGlobalModal.parentGlobalModalMultipleInputs.accountingGroup =
          action?.payload ? action?.payload : '';
      } else {
        state.multipleInputsSelectedValues.accountingGroup = action?.payload
          ? action?.payload
          : '';
      }
    },

    handleSearchTermObjOrderNo: (state, action) => {
      state.selectedSearchTermOrderNo = action?.payload;
    },
    handleSearchTermOrderNo: (state, action) => {
      state.searchTermOrderNo = action?.payload;
    },
    handleSearchTermObjSiteId: (state, action) => {
      state.selectedSearchTermSiteId = action?.payload;
    },
    handleSearchTermSiteId: (state, action) => {
      state.searchTermSiteId = action?.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(customerNameSmartSearchData.pending, (state) => {
        state.inputError = null;
      })
      .addCase(customerNameSmartSearchData.fulfilled, (state, action) => {
        if (state.parentGlobalModal.openParentGlobalCustomerNoModal) {
          state.parentGlobalModal.name =
            action?.payload?.length > 0 ? action?.payload : [];
        } else {
          state.name = action?.payload?.length > 0 ? action?.payload : [];
        }
      })
      .addCase(customerNameSmartSearchData.rejected, (state, action) => {
        state.inputError = action?.payload;
      })

      .addCase(fetchAccountingGroups.pending, (state) => {
        state.isAccountingGroupsResultsFound = false;
        state.accountingGroupModal.accountingGroupSearchData = [];
        state.accountingGroupModal.accountingGroupGridTotalRecords = 0;
        state.loading = true;
        state.loadingAccountingGroup = false;
      })
      .addCase(fetchAccountingGroups.fulfilled, (state, action) => {
        state.loading = false;
        if (action?.payload?.accountingGroups?.length > 0) {
          state.accountingGroupModal.accountingGroups = action?.payload;
          state.accountingGroupModal.accountingGroupSearchData =
            action?.payload?.accountingGroups;
          state.accountingGroupModal.accountingGroupGridTotalRecords =
            action?.payload ? action?.payload?.totalCount : 0;
          state.isAccountingGroupsResultsFound = true;
          state.loadingAccountingGroup = false;
        } else {
          state.accountingGroupModal.accountingGroups = [];
          state.accountingGroupModal.accountingGroupSearchData = [];
          state.accountingGroupModal.accountingGroupGridTotalRecords = 0;
          state.isAccountingGroupsResultsFound = true;
          state.loadingAccountingGroup = false;
        }
      })
      .addCase(fetchAccountingGroups.rejected, (state) => {
        state.accountingGroupModal.accountingGroupSearchData = [];
        state.accountingGroupModal.accountingGroups = [];
        state.accountingGroupModal.accountingGroupGridTotalRecords = 0;
        state.isAccountingGroupsResultsFound = true;
        state.loading = false;
        state.loadingAccountingGroup = false;
      })

      .addCase(getSearchByCostomerId.pending, (state) => {
        state.gCNumberLoader = true;
        state.errorModal = null;
        state.searchResult = [];
        state.selectedRowData = [];
      })
      .addCase(getSearchByCostomerId.fulfilled, (state, action) => {
        state.gCNumberLoader = false;
        if (action?.payload) {
          state.selectedRowData = action?.payload;
          state.errorModal = null;
          state.displayButtonValue = true;
        } else {
          state.selectedRowData = [];
          state.errorModal = action?.meta?.arg
            ? action.meta?.arg
            : 'enterValue';
          state.displayButtonValue = false;
        }
      })
      .addCase(getSearchByCostomerId.rejected, (state, action) => {
        state.gCNumberLoader = false;
        state.errorModal = action?.meta?.arg ? action.meta?.arg : 'enterValue';
      })

      .addCase(getSearchByMultipleInputs.pending, (state) => {
        state.loading = true;
        state.inputError = null;
        state.searchResult = [];
        state.selectedRowData = [];
        state.customersGridTotalRecords = 0;
        state.customersGridResultsFound = false;
      })
      .addCase(getSearchByMultipleInputs.fulfilled, (state, action) => {
        state.loading = false;
        if (action?.payload?.length > 0) {
          state.searchResult = action?.payload?.sort((a, b) => a.name - b.name);
          state.customersGridTotalRecords = action?.payload
            ? action?.payload[0]?.totalRecords
            : 0;
          state.customersGridResultsFound = true;
        } else {
          state.searchResult = [];
          state.customersGridTotalRecords = 0;
          state.customersGridResultsFound = true;
        }
      })
      .addCase(getSearchByMultipleInputs.rejected, (state, action) => {
        state.loading = false;
        state.inputError = action?.payload;
        state.customersGridTotalRecords = 0;
        state.customersGridResultsFound = true;
      })

      .addCase(getSearchByMultipleInputsParentGlobalModal.pending, (state) => {
        state.loading = true;
        state.parentGlobalModal.parentGlobalGridData = [];
        state.parentGlobalModal.parentGlobalGridTotalRecords = 0;
        state.parentGlobalModal.isParentGlobalResultsFound = false;
      })
      .addCase(
        getSearchByMultipleInputsParentGlobalModal.fulfilled,
        (state, action) => {
          state.loading = false;
          if (action?.payload?.length > 0) {
            state.parentGlobalModal.parentGlobalGridData = action?.payload;
            action?.payload?.sort((a, b) => a.name - b.name);
            state.parentGlobalModal.parentGlobalGridTotalRecords =
              action?.payload ? action?.payload[0]?.totalRecords : 0;
            state.parentGlobalModal.isParentGlobalResultsFound = true;
          } else {
            state.parentGlobalModal.parentGlobalGridData = [];
            state.parentGlobalModal.parentGlobalGridTotalRecords = 0;
            state.parentGlobalModal.isParentGlobalResultsFound = true;
          }
        }
      )
      .addCase(
        getSearchByMultipleInputsParentGlobalModal.rejected,
        (state, action) => {
          state.loading = false;
          state.inputError = action?.payload;
          state.parentGlobalModal.parentGlobalGridTotalRecords = 0;
          state.parentGlobalModal.isParentGlobalResultsFound = true;
        }
      )

      .addCase(getDetailsByCostomerId.pending, (state) => {
        state.loading = true;
        state.customerDetails = initialState.customerDetails;
      })
      .addCase(getDetailsByCostomerId.fulfilled, (state, action) => {
        state.loading = false;
        state.customerDetails = action?.payload;
        state.billToCustomerCheckbox.serializedFlag =
          action.payload?.serializedFlag === 'y'
            ? CHECK_BOX_VALUE.yes
            : CHECK_BOX_VALUE.no;
      })
      .addCase(getDetailsByCostomerId.rejected, (state) => {
        state.loading = false;
        state.customerDetails = initialState.customerDetails;
      })

      .addCase(getAddressDetailsByCostomerId.pending, (state) => {
        state.loading = true;
        state.addressDetails = initialState.addressDetails;
      })
      .addCase(getAddressDetailsByCostomerId.fulfilled, (state, action) => {
        state.loading = false;
        state.addressDetails = action?.payload;
      })
      .addCase(getAddressDetailsByCostomerId.rejected, (state) => {
        state.loading = false;
        state.addressDetails = initialState.addressDetails;
      })

      .addCase(getCustomerHistory.pending, (state) => {
        state.customerHistoryDataFound = null;
        state.customerHistory = initialState.customerHistory;
      })
      .addCase(getCustomerHistory.fulfilled, (state, action) => {
        state.customerHistory = action?.payload?.customerHistoryList
          ? action?.payload?.customerHistoryList
          : [];
        if (state.customerHistory?.length > 0) {
          state.customerHistory.forEach((obj, index) => {
            obj.id = index + 1; // You can use any method to generate a ID key
            return obj;
          });
        }
        state.customerHistoryTotalRecords = action?.payload
          ? action?.payload?.totalRecords
          : 0;
        state.customerHistoryDataFound = true;
      })
      .addCase(getCustomerHistory.rejected, (state) => {
        state.customerHistoryDataFound = true;
      })

      .addCase(getCustomerChildren.pending, (state) => {
        state.customerChildrenDataFound = null;
        state.customerChildren = initialState.customerChildren;
      })
      .addCase(getCustomerChildren.fulfilled, (state, action) => {
        state.customerChildren = action?.payload?.customerChildrenList
          ? action?.payload?.customerChildrenList
          : [];
        if (state.customerChildren?.length > 0) {
          state.customerChildren.forEach((obj, index) => {
            obj.id = index + 1; // You can use any method to generate a ID key
            return obj;
          });
        }
        state.customerChildrenTotalRecords = action?.payload
          ? action?.payload?.totalRecords
          : 0;
        state.customerChildrenDataFound = action?.payload?.customerChildrenList?.length > 0;
      })
      .addCase(getCustomerChildren.rejected, (state) => {
        state.customerChildrenDataFound = true;
      })

      .addCase(getCustomerNotes.pending, (state) => {
        state.customerNotesDataFound = false;
        state.customerNotes = initialState.customerNotes;
        state.addedCustomerNote = initialState.addedCustomerNote;
        state.deletedCustomerNote = initialState.deletedCustomerNote;
        state.customerNotesLoading = true;
      })
      .addCase(getCustomerNotes.fulfilled, (state, action) => {
        state.customerNotes = action?.payload ? action?.payload : [];
        if (state.customerNotes?.length > 0) {
          state.customerNotes.forEach((obj, index) => {
            obj.id = index + 1;
            obj.old_last_Modified_Timestamp = obj.last_Modified_Timestamp;
            obj.last_Modified_Timestamp = globalDateFormat(
              obj?.last_Modified_Timestamp
            );

            return obj; // You can use any method to generate a ID key
          });
        }
        state.customerNotesTotalRecords = action?.payload
          ? action?.payload[0].totalRecords
          : 0;
        state.customerNotesDataFound = true;
        state.customerNotesLoading = false;
      })
      .addCase(getCustomerNotes.rejected, (state) => {
        state.customerNotesDataFound = true;
        state.customerNotesLoading = false;
      })

      .addCase(addCustomerNotes.pending, (state) => {
        state.addedCustomerNote = initialState.addedCustomerNote;
        state.customerNotes = initialState.customerNotes;
        state.customerNotesDataFound = false;
        state.customerNotesTotalRecords = 0;
        state.customerNotesLoading = true;
      })
      .addCase(addCustomerNotes.fulfilled, (state) => {
        if (state.addCustomerNotes.isEdit) {
          state.addedCustomerNote = 'Updated';
        } else {
          state.addedCustomerNote = 'Added';
        }
        state.addCustomerNotes = initialState.addCustomerNotes;
        state.customerNotesLoading = false;
      })
      .addCase(addCustomerNotes.rejected, (state) => {
        if (state.addCustomerNotes.isEdit) {
          state.addedCustomerNote = 'notUpdated';
        } else {
          state.addedCustomerNote = 'notAdded';
        }
        state.customerNotesLoading = false;
      })

      .addCase(deleteCustomerNotes.pending, (state) => {
        state.customerNotes = initialState.customerNotes;
        state.customerNotesDataFound = false;
        state.customerNotesTotalRecords = 0;
        state.customerNotesLoading = true;
      })
      .addCase(deleteCustomerNotes.fulfilled, (state) => {
        state.deletedCustomerNote = 'Deleted';
        state.customerNotesLoading = false;
      })
      .addCase(deleteCustomerNotes.rejected, (state) => {
        state.deletedCustomerNote = 'notDeleted';
        state.customerNotesLoading = false;
      })

      .addCase(orderNumberSmartSearchData.pending, (state) => {
        state.orderNumber = [];
      })
      .addCase(orderNumberSmartSearchData.fulfilled, (state, action) => {
        if (action?.payload?.length > 0) {
          state.orderNumber = action?.payload;
        } else {
          state.orderNumber = [];
        }
      })
      .addCase(orderNumberSmartSearchData.rejected, (state) => {
        state.orderNumber = [];
      })

      .addCase(siteIDSmartSearchData.pending, (state) => {
        state.siteID = [];
      })
      .addCase(siteIDSmartSearchData.fulfilled, (state, action) => {
        if (action?.payload?.length > 0) {
          state.siteID = action?.payload;
        } else {
          state.siteID = [];
        }
      })
      .addCase(siteIDSmartSearchData.rejected, (state) => {
        state.siteID = [];
      })

      .addCase(getCustomersBy_OrderNumber_SiteID.pending, (state) => {
        state.salesOrdersCustomers = [];
        state.isSalesOrderDataFound = false;
        state.salesOrdersTotalCount = 0;
        state.loadCustSalesOrder = true;
      })
      .addCase(getCustomersBy_OrderNumber_SiteID.fulfilled, (state, action) => {
        state.isSalesOrderDataFound = true;
        if (action?.payload?.length > 0) {
          state.salesOrdersCustomers = action?.payload;
          state.salesOrdersTotalCount = action?.payload[0]?.totalRecords;
        } else {
          state.salesOrdersCustomers = [];
          state.salesOrdersTotalCount = 0;
        }
        state.loadCustSalesOrder = false;
      })
      .addCase(getCustomersBy_OrderNumber_SiteID.rejected, (state) => {
        state.salesOrdersCustomers = [];
        state.isSalesOrderDataFound = true;
        state.loadCustSalesOrder = false;
      })

      //Customer Entitlement Summary
      .addCase(bySearchEntitlementSummary.pending, (state) => {
        state.loading = true;
        state.customerEntitlementSummaryDataFound = null;
        state.customerEntitlementSummary = [];
      })
      .addCase(bySearchEntitlementSummary.fulfilled, (state, action) => {
        state.customerEntitlementSummary = action?.payload
          ? action.payload
          : [];
        state.customerEntitlementSummaryTotalRecords = action?.payload
          ? action?.payload[0]?.totalRecords
          : 0;
        state.loading = false;
        state.customerEntitlementSummaryDataFound = action?.payload?.length > 0;
      })
      .addCase(bySearchEntitlementSummary.rejected, (state) => {
        state.loading = false;
        state.customerEntitlementSummaryDataFound = false;
      })

      //Customer Entitlement Summary
      .addCase(bySearchCustomerSite.pending, (state) => {
        state.loading = true;
        state.customerSitesDataFound = true;
        state.customerSites = [];
      })
      .addCase(bySearchCustomerSite.fulfilled, (state, action) => {
        state.customerSites = action?.payload ? action.payload : [];
        state.customerSitesTotalRecords = action?.payload
          ? action?.payload[0]?.totalRecords
          : 0;
        state.loading = false;
        state.customerSitesDataFound = false;
      })
      .addCase(bySearchCustomerSite.rejected, (state) => {
        state.loading = false;
        state.customerSitesDataFound = false;
      })

      //Customer Bill Notes
      .addCase(fetchCustomerBillNotesData.pending, (state) => {
        state.customerBillNotesDataFound = null;
        state.customerBillNotes = [];
      })
      .addCase(fetchCustomerBillNotesData.fulfilled, (state, action) => {
        state.customerBillNotes = action?.payload?.customerBillingNotes || [];
        state.customerBillNotesTotalRecords =
          action?.payload?.totalRecords || 0;
        state.customerBillNotesDataFound =
          action?.payload?.customerBillingNotes?.length > 0;
      })
      .addCase(fetchCustomerBillNotesData.rejected, (state, action) => {
        state.customerBillNotesDataFound = true;
        state.customerBillNotes = [];
        state.customerBillNotesTotalRecords =
          action?.payload?.totalRecords || 0;
      })

      //Customer Billing Bills
      .addCase(fetchCustomerBillingBills.pending, (state) => {
        state.customerBillsBillDataFound = true;
        state.customerBillsBill = [];
        state.billingViewData = [];
      })
      .addCase(fetchCustomerBillingBills.fulfilled, (state, action) => {
        state.customerBillsBill = action?.payload?.customerBills || [];
        state.customerBillsBillTotalRecords =
          action?.payload?.totalRecords || 0;
        state.customerBillsBillDataFound = false;
      })
      .addCase(fetchCustomerBillingBills.rejected, (state) => {
        state.customerBillsBillDataFound = false;
        state.customerBillsBill = [];
        state.customerBillsBillTotalRecords = 0;
      })

      .addCase(updateCustomersInfo.pending, (state) => {
        state.customerInfoUpdated = null;
        state.customerInfoUpdateLoading = true;
      })
      .addCase(updateCustomersInfo.fulfilled, (state) => {
        state.customerInfoUpdated = true;
        state.customerInfoUpdateLoading = false;
      })
      .addCase(updateCustomersInfo.rejected, (state) => {
        state.customerInfoUpdated = false;
        state.customerInfoUpdateLoading = false;
      })

      .addCase(viewBillingData.pending, (state) => {
        state.billingViewLoading = true;
        state.billingViewData = [];
        state.billingViewCount = 0;
      })
      .addCase(viewBillingData.fulfilled, (state, action) => {
        state.billingViewLoading = false;
        state.billingViewData = action?.payload?.pendingBills || [];
        state.billingViewCount = action?.payload?.totalRecords
          ? action?.payload?.totalRecords
          : 0;
      })
      .addCase(viewBillingData.rejected, (state) => {
        state.billingViewLoading = false;
        state.billingViewData = [];
        state.billingViewCount = 0;
      })
      .addCase(entitlementSummaryEmail.pending, (state) => {
        state.loadingCustomerEntitlementSummaryEmail = true;
        state.customerEntitlementSummaryMailResponse = null;
      })
      .addCase(entitlementSummaryEmail.fulfilled, (state, action) => {
        state.customerEntitlementSummaryMailResponse = action?.payload
          ? action.payload
          : null;
        state.loadingCustomerEntitlementSummaryEmail = false;
      })
      .addCase(entitlementSummaryEmail.rejected, (state) => {
        state.loadingCustomerEntitlementSummaryEmail = false;
        state.customerEntitlementSummaryMailResponse = false;
      });
  },
});

export const {
  setSelectedRowData,
  setSelectedTabValue,
  setIsExpandedValue,
  setGlobalCustomerNo,
  setSelectedComponent,
  setSelectedValue,
  setCustomerNameInputValue,
  resetValues,
  setDropDownValue,
  setDisplayButtonValue,
  setSelectedAccountGridRowsData,
  setAccountingGroupModalOpen,
  setParentGlobalCustomerNoModalOpen,
  setAccountingGroupModalClose,
  setParentGlobalCustomerNoModalClose,
  setAccouningGroupFormFeilds,
  setBillToCustomerChange,
  setCustomerNameSearchTerm,
  setShowCustomernameSelectedValue,
  setSelectedParentGlobalGridRowsData,
  setCustomersGridPageSize,
  setCloseAlertDialog,
  customerDetailResetValues,
  displayEnterValue,
  setBackToPreviousPage,
  setCustomerNotesOpenCloseModal,
  customerAddNotesState,
  setDisplayDeleteAlert,
  setEditNoteData,
  setHandelReset,
  setEffectiveDate,
  setStatus,
  setSearch,
  setSiteNameContaines,
  setSiteNcrIdContaines,
  setSiteActive,
  setNavigateToSite,
  setCustomerNumber,
  setAGOnChange,
  handleSearchTermObjOrderNo,
  handleSearchTermOrderNo,
  handleSearchTermObjSiteId,
  handleSearchTermSiteId,
} = CustomersSearchSlice.actions;
export default CustomersSearchSlice.reducer;
